import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { colors } from '../tokens'

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '2px 8px',
    borderRadius: '999px',
    background: colors.chip,
    fontSize: '11px',
    fontWeight: 500,
    color: colors.slate,
    whiteSpace: 'nowrap',
  },
  large: {
    padding: '4px 10px',
    fontSize: '12px',
  },
  removable: {
    paddingRight: '6px',
  },
  remove: {
    display: 'inline-flex',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    color: colors.subtle,
  },
  removeIcon: {
    width: 12,
    height: 12,
  },
})

/** Rounded gray tag; `onRemove` adds an × button. */
const Chip = ({ label, size = 'small', onRemove }) => {
  const classes = useStyles()

  return (
    <span
      className={[
        classes.root,
        size === 'large' && classes.large,
        onRemove && classes.removable,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label}
      {onRemove && (
        <button
          type="button"
          title="Remove"
          className={classes.remove}
          onClick={onRemove}
        >
          <Icon icon="tabler:x" className={classes.removeIcon} />
        </button>
      )}
    </span>
  )
}

export default Chip
